// ABOUTME: Family definition for the relation/orders grids — siblings that can share saved layouts.
// ABOUTME: Each entry pairs a gridKey with an i18n label key used by the "share with" dropdown.

export const RELATION_RETURNS_FAMILY = {
    PROCESSED: {
        gridKey: "relations.returns.processed",
        label: "processed_returns",
    },
    EXPECTED: {
        gridKey: "relations.returns.expected",
        label: "expected_returns",
    },
    COMPLETED: {
        gridKey: "relations.returns.completed",
        label: "completed_returns",
    },
};
